var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchClearButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#D9E3E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.00671L13.0067 12L17 15.9933L15.9933 17L12 13.0067L8.00671 17L7 15.9933L10.9933 12L7 8.00671L8.00671 7L12 10.9933L15.9933 7L17 8.00671Z",
    fill: "#78868E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchClearButton);
export default __webpack_public_path__ + "static/media/SearchClearButton.954cf1b2a94edfaad42ca33628498cbb.svg";
export { ForwardRef as ReactComponent };